module.exports = __webpack_public_path__ + "static/img/news-img1.8f9672d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news-img1.png
// module id = JhAx
// module chunks = 3